import { call, put, takeEvery } from 'redux-saga/effects';
import { addPriceSuggestion as addPriceSuggestionReq, getPriceSuggestion as getPriceSuggestionReq } from '../../requests/bikeModel.requests';
import { message_success, message_error } from '../../../../../components/Message';
import { ADD_BIKE_MODEL_NEW_PRICE_SUGGESTION_SAGA } from '../constants/bikeModel.constants';
import { SET_MODAL_WINDOW_DATA, CLOSE_MODAL_WINDOW } from '../../../../App/redux/constants/modalWindow.constants';

function* addPriceSuggestion({ modelId, newRecord }) {
    yield put({ type: SET_MODAL_WINDOW_DATA, payload: { isLoading: true } });

    const res = yield call(addPriceSuggestionReq, modelId, newRecord);

    yield put({ type: CLOSE_MODAL_WINDOW });

    if (res.result) {
        const { options: modelData } = yield call(getPriceSuggestionReq, modelId);

        yield put({
            type: 'SET_REF_BIKE_LEAD_DATA',
            payload: {
                'bike_details.ref_bike_model.price_suggestions': modelData.price_suggestions,
            },
        });
        // yield put(addNoteRequestSuccess(data.options.notes));
        message_success('Price suggestion added successfully!');
    } else {
        // yield put(addNoteRequestFailure(error));
        message_error('Something gone wrong!');
    }
}

export default function* addPriceSuggestionSaga() {
    yield takeEvery(ADD_BIKE_MODEL_NEW_PRICE_SUGGESTION_SAGA, addPriceSuggestion);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/sagas/addPriceSuggestion.js